import {Directive, HostListener, Input, OnInit} from '@angular/core';

@Directive({
  selector: '[gp-resizer]'
})
export class ResizerDirective implements OnInit {

  @Input()
  private leftElement: HTMLElement;
  @Input()
  private rightElement: HTMLElement;
  @Input()
  private maxSize: number = 50;
  @Input()
  private minSize: number = 50;
  private grabber: boolean = false;

  public ngOnInit() {
    this.leftElement.style.minWidth = `${this.minSize}%`;
    this.leftElement.style.maxWidth = `${this.maxSize}%`;
  }

  @HostListener('mousedown')
  onMouseDown() {
    this.grabber = true;
    document.body.style.cursor = 'col-resize';
  }

  @HostListener('window:mouseup')
  onMouseUp() {
    this.grabber = false;
    document.body.style.cursor = 'default';
  }

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    if (!this.grabber) {
      return;
    }
    const offsetLeft = this.leftElement.parentElement.offsetLeft;
    const parentWidth = this.leftElement.parentElement.clientWidth;
    const widthLeft = event.clientX - offsetLeft;
    const leftPercentage = Math.round((widthLeft - 5) * 100 / parentWidth);

    if (leftPercentage >= this.minSize && leftPercentage <= this.maxSize) {
      this.leftElement.style.flex = `1 1 ${widthLeft - 5}px`;
      this.rightElement.style.flex = `0 1 ${parentWidth - widthLeft}px`;
    }
  }
}
